import { createContext, useContext, useState, ReactNode } from 'react';

type PortfolioFilter = 'all' | 'strategy' | 'organization' | 'digital';

interface PortfolioContextType {
  activeFilter: PortfolioFilter;
  setActiveFilter: (filter: PortfolioFilter) => void;
}

const PortfolioContext = createContext<PortfolioContextType | undefined>(undefined);

export function usePortfolio() {
  const context = useContext(PortfolioContext);
  if (context === undefined) {
    throw new Error('usePortfolio must be used within a PortfolioProvider');
  }
  return context;
}

interface PortfolioProviderProps {
  children: ReactNode;
}

export function PortfolioProvider({ children }: PortfolioProviderProps) {
  const [activeFilter, setActiveFilter] = useState<PortfolioFilter>('all');

  const value = {
    activeFilter,
    setActiveFilter,
  };

  return <PortfolioContext.Provider value={value}>{children}</PortfolioContext.Provider>;
}
